import { render, staticRenderFns } from "./ItemsTab.vue?vue&type=template&id=cbc0484a&"
import script from "./ItemsTab.vue?vue&type=script&lang=js&"
export * from "./ItemsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports